import React, { useState, useEffect } from "react";
import {
  Alert,
  Form,
  Pagination,
  Accordion,
  Card,
  Button,
} from "react-bootstrap";
import micro_reporter_api from "../../apis/micro-reporter-api";
import ReportList from "./ReportList";
import InputGenerator from "../Input/InputGenerator";
import hideArrow from "../../assets/img/hide_arrow.png";
import showArrow from "../../assets/img/show_arrow.png";
import "../../styles/css/ReportPanel.css";
import Utils from "../../libraries/utils";

const QueryForm = (props) => {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  let errorMessage =
    "An unexpected error was encountered! Error may have occurred due to the database connection.";

  const [values, setValues] = useState({ values: {} });
  const [offset, setOffset] = useState(0);
  const [rowNumber, setRowNumber] = useState(10);

  const [columnMetadata, setColumnMetadata] = useState([]);

  const [isDisabled, setDisabled] = useState("");
  const [showReportList, setShowReportList] = useState(true);
  const [showPagination, setShowPagination] = useState(true);

  const [reportName, setReportName] = useState("");
  const [projectName, setProjectName] = useState("");

  const [reportDcId, setReportDcId] = useState(0);
  const [reportPid, setReportPid] = useState(0);

  const [isAccordionActive, setIsAccordionActive] = useState(false);

  let rid = props.isWidget
    ? Number(props.rid)
    : new URLSearchParams(window.location.search).get("id");

  useEffect(() => {
    getReportName();
    // getProjectName();
    getReportInfo();
  }, [props.rid]);

  const getReportName = () => {
    let id = rid;
    if (id !== null) {
      try {
        Utils.loadingScreen("show");
        (async () => {
          await micro_reporter_api
            .get(`/micro-reporter/report/find-name-by-id?id=${id}`)
            .then((response) => {
              setReportName(response.data.name);
              setProjectName(response.data.projectName);
              Utils.loadingScreen("hide");
              getColumnMetaData();
            });
        })();
      } catch (e) {
        Utils.loadingScreen("hide");
      }
    }
  };

  const getReportInfo = () => {
    let id = rid;
    if (id !== null) {
      try {
        Utils.loadingScreen("show");
        (async () => {
          await micro_reporter_api
            .get(`/micro-reporter/report/get-info?id=${id}`)
            .then((response) => {
              setReportDcId(response.data.dcId);
              setReportPid(response.data.projectId);
              Utils.loadingScreen("hide");
              getColumnMetaData();
            });
        })();
      } catch (e) {
        Utils.loadingScreen("hide");
      }
    }
  };

  const getColumnMetaData = () => {
    let columnValueMap = {};
    let user = JSON.parse(localStorage.getItem("user"));
    const model = {
      columnValueMap: columnValueMap,
      columnMetadataMap: null,
      offset: 0,
      rows: 1,
      rid: rid,
    };
    let headers = {
      userId: user.id,
      username: user.username,
      relatedName: encodeURIComponent(reportName),
      relatedId: model.rid,
    };
    const config = { headers };
    try {
      Utils.loadingScreen("show");
      (async () => {
        await micro_reporter_api
          .post("/micro-reporter/report/filter-report", model, config)
          .then((response) => {
            setColumnMetadata(Object.entries(response.data.columnMetadataMap));
            Utils.loadingScreen("hide");
            if (!response.data.canViewExport[0]) {
              window.location.href = "/dashboard";
            }
          });
      })();
    } catch (err) {
      Utils.loadingScreen("hide");
      setShowErrorMessage(true);
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const renderPagination = () => {
    if (showPagination) {
      return (
        <div id="report-panel-pagination-div">
          <Pagination id="report-panel-pagination">
            <Pagination.Prev onClick={() => prevPage()} />
            <Pagination.Item>{offset + 1}</Pagination.Item>
            <Pagination.Next onClick={() => nextPage()} disabled={isDisabled} />
          </Pagination>

          <Form.Control
            as="select"
            onChange={() => setRN()}
            id="report-panel-pagination-select"
          >
            <option key="10" selected={rowNumber === 10 ? "selected" : ""}>
              10
            </option>
            <option key="20" selected={rowNumber === 20 ? "selected" : ""}>
              20
            </option>
            <option key="50" selected={rowNumber === 50 ? "selected" : ""}>
              50
            </option>
          </Form.Control>
        </div>
      );
    }
  };

  const setRN = () => {
    setRowNumber(
      parseInt(document.getElementById("report-panel-pagination-select").value)
    );
    setOffset(0);
  };

  const prevPage = () => {
    if (offset > 0) {
      setOffset(offset - 1);
    }
  };

  const nextPage = () => {
    setOffset(offset + 1);
  };

  const disableButton = () => {
    setDisabled("disabled");
  };

  const enableButton = () => {
    setDisabled("");
  };

  const renderReportList = () => {
    if (showReportList) {
      return (
        <div>
          {reportName !== "" ? (
            <ReportList
              values={values.values}
              enableButton={enableButton}
              disableButton={disableButton}
              isAccordionActive={isAccordionActive}
              setShowErrorMessage={setShowErrorMessage}
              showPagination={setShowPagination}
              offset={offset}
              rowNumber={rowNumber}
              columnMetadata={columnMetadata}
              reportName={reportName}
              rid={rid}
              isWidget={props.isWidget}
            />
          ) : null}
          {renderPagination()}
        </div>
      );
    }
  };

  const showReportListPanel = () => {
    setShowReportList(true);
  };

  const hideReportListPanel = () => {
    setShowReportList(false);
  };

  const renderAccordionText = () => {
    if (isAccordionActive) {
      return (
        <div>
          <span>Hide Filters</span>
          <img
            style={{ width: "16px", height: "16px", marginLeft: "6px" }}
            src={showArrow}
          />
        </div>
      );
    } else {
      return (
        <div>
          <span>Show Filters</span>
          <img
            style={{ width: "16px", height: "16px", marginLeft: "6px" }}
            src={hideArrow}
          />
        </div>
      );
    }
  };

  const renderInputGenerator = () => {
    if (!showErrorMessage && !props.isWidget) {
      return (
        <Accordion defaultActiveKey="1">
          <Card
            style={{
              borderBottomStyle: "none",
              borderRadius: ".25rem .25rem 0 0",
              overflow: "visible",
            }}
          >
            <Card.Header style={{ padding: "0" }}>
              <Accordion.Toggle
                className="filter-panel-accordion"
                as={Button}
                onClick={() => setIsAccordionActive(!isAccordionActive)}
                variant="link"
                eventKey="0"
                style={{ float: "right" }}
              >
                {renderAccordionText()}
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0" style={{ padding: "10px 5px 0" }}>
              <InputGenerator
                rid={rid}
                columnMetadata={columnMetadata}
                setVals={setValues}
                setOffset={setOffset}
                showReportListPanel={showReportListPanel}
                hideReportListPanel={hideReportListPanel}
              />
            </Accordion.Collapse>
          </Card>
        </Accordion>
      );
    }
  };

  const linkToReport = () => {
    if (props.isWidget) {
      window.location.href = "/report?id=" + Number(props.rid);
    }
  };

  const linkToEditReport = () => {
    if (reportDcId !== 0 && reportPid !== 0) {
      window.location.href =
        "/report/form?projectId=" +
        reportPid +
        "&dcid=" +
        reportDcId +
        "&id=" +
        rid;
    }
  };

  const renderEditReportButton = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role === "ADMIN" && !props.isWidget) {
      return (
        <i
          className="fa fa-pencil"
          onClick={() => linkToEditReport()}
          style={{
            color: "#0C5DB6",
            cursor: "pointer",
            display: "inline-table",
            paddingTop: "4px",
          }}
          title="Edit Report"
        ></i>
      );
    }
  };

  return (
    <div style={{ margin: props.isWidget ? "0" : "0 20px 2px 80px" }}>
      <div id="report-page-div">
        <div
          id="query-form-panel"
          style={{ paddingTop: props.isWidget ? "3px" : "30px" }}
        >
          <div>
            <h5
              onClick={() => linkToReport()}
              className="page-title"
              title={reportName}
              style={
                props.isWidget
                  ? {
                      marginBottom: "12px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }
                  : { marginBottom: "40px" }
              }
            >
              {reportName} - {projectName}
              {renderEditReportButton()}
            </h5>
            <Button
              variant="primary"
              id="all-reports-page-button"
              className="all-reports-page-buttonn"
            >
              <i class="fa-solid fa-chevron-left"></i>

              <a className="link" href={"/reports"}>
                All Reports
              </a>
            </Button>
            {showErrorMessage ? (
              <Alert variant="danger">{errorMessage}</Alert>
            ) : null}
          </div>
          {renderInputGenerator()}
        </div>
        {renderReportList()}
      </div>
    </div>
  );
};

export default QueryForm;
